module.exports = __webpack_public_path__ + "static/themes-layers-do-06862381aeec982542140149eedcae5a.png";